import { render, staticRenderFns } from "./password-type.vue?vue&type=template&id=5c5b79fb&scoped=true&lang=pug&"
import script from "./password-type.vue?vue&type=script&lang=ts&"
export * from "./password-type.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5b79fb",
  null
  
)

export default component.exports